import { Intent } from '@blueprintjs/core';

export const statusIntent = (status: string): Intent => {
  if (status == 'Open') return Intent.PRIMARY;
  if (status == 'Closed') return Intent.SUCCESS;
  if (status == 'On Hold' || status == 'Needs Review') return Intent.WARNING;
  if (status == 'Fail' || status == 'No') return Intent.DANGER;
  return Intent.NONE;
}
